






















import Vue from 'vue';
import store from '../store';

export default Vue.component('bacon-steps', {
    computed: {
        steps() {
            return store.getters.steps;
        },
        maxPageN() {
            const maxPage = store.state.maxPage;
            return (maxPage ? maxPage.n : -1) + 1;
        },
    },
});
